module.exports = {
    all:'Completed',
    stop:'Terminated',
    ing:'In progress',
    operate:'Operate',
    price:'KOL Price',
    payment:'Payment',
    schedule:'Estimated Schedule',
    remarks:'Remarks',
    cancelSuccess:'Progress stop success',
    cancelFail:'Progress stop fail',
    baiscinfo:'Basic Info',
    Client:'Advertiser',
    haveexist:'The URL already exists in the table. Please modify it',
    Product:'Product',
    Country:'Country',
    adds:'',
    newsugges:'Please provide your feedback on the script.',
    newsugges2:'Please provide your feedback on the content..',
    jiaobeninput:'Script Link Entry',
    templeteInfo:'Template Info',
    ctu:'Click to upload',
    addtoco:'Add from collection',
    Submit:'Submit',
    campaignName:'Campaign Name',
    ecom:'E-commerce',
    sor_stop:'We regret that you have terminated our cooperation',
    need_more:'If you need to work again, please contact your business manager',
    game:'Game',
    fgp:'For games products',
    marketing:'Project Name',
    marketings:'Project',
    fecp:'For e-commerce products',
    rlc:'Referral List Creation',
    uploads:'Upload',
    spn:'Select product name',
    id:'ID',
    completedUploadedFiles:'completed Nums',
    current:'Current Process',
    full:'Full Process',
    waitConfirm:'List of KOL to be confirmed',
    addlink:'Add Content Link',
    addlinkdesc:'Add other infomation',
    Brief:'Brief',
    Brief2:'Brief',
    saves:'Add Save',
    timeSet:'Set the estimated end time',
    exchange:'Free exchange',
    ohters:'Others',
    advprice:'Estimated Price',
    advprice2:'Cooperative Price',
    proname:'Product Name',
    blf:'Promotion link',
    links:'Content Link',
    xx:'Source file upload',
    kltbc:'KOL List To Be Confirmed',
    upoe:'Upload the order email',
    kl:'KOL List',
    contentnone:'This field or file is required and cannot be empty.',
    t1:"Please select",
    t2:'Please select',
    picor:'（picture/video）',
    t3:'Please select',
    addkol:'Add KOL',
    intentList:'Intentions List',
    confirmEmail:'Please confirm the order email',
    kolcontract:'KOL Contract',
    address:'Address',
    pamentc:'Payment Voucher',
    invoiceIfo:'Invoice Info',
    pia:'Please input address',
    pic:'Please input city',
    pitrackLink:'Please input tracking link',
    pitrackingNum:'Please input tracking number',
    pisampleModel:'Please input sample model',
    piidCode:'Please input ID number',
    pis:'Please input state',
    pico:'Please input country',
    piz:'Please input post code',
    pip:'Please input phone number',
    city:'City',
    idCode:'ID Number',
    zip:'Post Code',
    phone:'Phone Number',


    feedbacks:'Could you please provide your feedback on the content?',



    kolinfo:'KOL Info',
    kolname:'Name',
    dress:'Address',
    jiaobens:'Content',
    jiaobens2:'Script',
    status:'Status',
    uptime:'Upload time',
    ncri:'Customers are required to fill in information',
    otherInfo:'Other Information',
    proInfos:'Product Data',
    rq:'Release requirements',
    logistics:'Logistics information',
    savelink:'Save Link',

    linkss:'Link',
    beizhu:'Remark',
    zero:"Intention",
    one:'Order',
    two:'Order',
    three:'KOLs Contract',
    four:'Material',
    five:'Sample',
    six:'Script',
    seven:'Content',
    eight:'Content',
    nine:'Closing',
    ten:'Entry',
    0:'Intention Confirm',
    1:'Order Execution Result',
    2:'Order Execution',
    3:"KOL's Contract Signing",
    4:'Material Support',
    5:'Sample Trial',
    6:'Script Review',
    7:'Content Review',
    8:'Content Online',
    9:'Closing Report',
    10:'Entry Kol Info',


    Entry:'Entry',
    Kol_Info:'Kol Info',
    Confirmations:'Confirm',
    Confirmation:'Execution', 
    Execution:'Execution',
    Signing:'Signing',
    Support:'Support',
    Receipt:'Trial',
    Script:'Review',
    Video:'Review',
    Issue:'Online',
    Report:'Report',
    filesuggest:'You are advised to upload files smaller than 200M',
    step:'step',
    uploadNone:'upload file cannot be empty',
    uploadreportNone:'Upload Report cannot be empty',
    addempty:'Address,city,country and phone number cannot be empty',
    waieadvmeterial:'The advertiser is filling out the materials, please wait a moment.',
    materialwaite:'We are organizing the material requirements, please wait a moment.',
    opration_after:'We are confirming the information you have uploaded, please wait a moment.',
    bloggerget:'Is the influencer starting to trial the products?',
    bloggerdoing:"The blogger's sample is being confirmed",
    bloggerrecive:'If the blogger receives the sample, please click the button below',
    bloggersure:'The blogger is confirming the sample, please wait patiently',
    havegetSimle:'Influencers have started trialing products',
    got:'I Got it',
    sure:'Yes',
    waitesie:'The script is on the way. Please wait a moment.',
    rejecthave:'Has already rejected',
    moretwo:'Upload up to two files',
    jiaoben:'Script upload',
    jiaobenrecord:'Script upload record',
    sugg:'Suggestion',
    waitadv:'Waiting for advertisers to review',
    waitVideo:'We are waiting for the operation team to upload the content.',
    videoup:'Content upload',
    videos:'Content',
    videouprecord:'Content upload record',
    novideo:'No Video or Picture',
    wacv:'We are waiting for the advertiser to approve the content.',
    operLik:'Waiting for media partner to fill in the link',
    advLink:'Waiting for advertisers to review the content',
    linksno:'Link cannot be empty.',
    itsr:'Is the closing report of the process uploaded?',
    tcriup:'The closing report is under preparation, please wait patiently',
    hbctcr:'The closing report has been completed. Please go to the report library to view',
    see:'Go to see it!',
    shenpi:'Approval',
    jivwoe:'The closing report of this process has been uploaded',
    aipkw:'The advertiser is selecting online celebrities. Please wait',
    wfewidvji:'Waiting for the operation team to confirm the order email with you.',
   
    pubf:'Please upload the promotion requirements file',
    pckf:'Please select the KOL folder',
    pcadv:'Please fill in the information above',
    pcproduct:'Please select product',
    pcCountry:'Please select country',
    pctemplete:'Select template information',
    kolic:"KOL's Intention Confirmation",
    fp:'Full process',
    choosekol:'You have to choose one kol at least',
    nochoose:'Customers are required to fill in information can not be empty',
    submitok:'submit success',
    Reject:'Reject',
    Paypal:'Paypal',
    Wire:'Wire',
    notbefore:'Start date cannot be earlier than today',

    pro:'Product Information',
    release:'Release Requirements',
    logs:'Logistics Information',
    chfis:'please choose the advertiser first',
    advname:'Advertiser',
    productname:'Product',
    plip:'Product name search',
    mlip:'Project name search',
    repeats:'produce name duplicate',
    exists:'The project name is used in the process , cannot be deleted',
    mar_repeats:'Project name duplicate',
    havesamekols:'Under the national advertiser of the same product, KOL cannot be repeated',
    pipn:'Please input product name',
    pimn:'Please input project name',
    psanew:'Please select advertiser',

    piap:'Please input product name',
    pdcbe:'Product Data cannot be empty',
    rrcbe:'Release requirements cannot be empty',
    licbe:'Logistics information cannot be empty',
    moretoFive:'Up to 5 files can be uploaded',
    ncu:"It's not a correct URL",
    Agree:'Agree',
    noaut:'No permission',
    sampleModel:'Sample Model',
    trackingNum:'Tracking Number',
    mustfill:'For the selected column, data cannot be empty',
    trackLink:'Tracking Link',
    channel:'Channel',
    influencerArea:'Influencer Area',
    totalVideos:'Total Videos',
    cartTitle:' KOL Cart',
    subscribers:'Subscribers',
    createChildren:'Trying to generate subprocesses...',
    suggs:'Could you please provide your feedback on the script?',
    shi:'Yes',
    collaborator:"Owner",
    nosupport:'The current file format is not supported in preview',
    datafinish:'Estimated Delivery Date:',

    init:'Initializing',
    mp_submited:'Intention Confirm',
    cust_approved:'PM Confirm',
    campaign_start :'Campaign Start',
    cust_reject:'Cust Reject',
    mp_reject:'AM Reject',
    remove:'Remove',
    submit_t:'Submit',
    start_order:'StartOrder',
    cancel:'Cancel',
    kol_a:'KOL Attribute',
    note:'Note',
    mcn:'MCN',
    individual:'Individual',
    broker:'Broker'
}


// WEBPACK FOOTER //
// ./src/i18n/modules/koltrack/en.js